/**
 * Visibility marker (design README shared kit, NFR-3 privacy guardrail). Public (eye, green) vs
 * Internal only (lock, amber). Public = what a resident sees; internal = staff-only. Text label +
 * icon (never color alone). Load-bearing: it's how staff see exactly what's public vs private.
 */
import type { Visibility } from "../api/types.js";

function EyeIcon() {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden="true"
    >
      <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
function LockIcon() {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden="true"
    >
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  );
}

export function VisibilityMarker({ visibility }: { visibility: Visibility }): JSX.Element {
  const isPublic = visibility === "public";
  return (
    <span className={`td-vis td-vis--${visibility}`}>
      {isPublic ? <EyeIcon /> : <LockIcon />}
      {isPublic ? "Public" : "Internal only"}
    </span>
  );
}
